"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var absorbedPackages_exports = {};
__export(absorbedPackages_exports, {
  absorbedPackageAliases: () => absorbedPackageAliases,
  absorbedPackageNames: () => absorbedPackageNames
});
module.exports = __toCommonJS(absorbedPackages_exports);
var import_fs = require("fs");
var import_path = __toESM(require("path"), 1);
var import_resolve = require("@vxrn/resolve");
var absorbedPackages = {
  "react-native-safe-area-context": "safe-area-context"
};
function undeclaredAbsorbedPackages(root) {
  var app = JSON.parse((0, import_fs.readFileSync)(import_path.default.join(root, "package.json"), "utf8"));
  var declared = {
    ...app.dependencies,
    ...app.devDependencies
  };
  return Object.entries(absorbedPackages).filter(function(param) {
    var [name] = param;
    return !(name in declared);
  });
}
function absorbedPackageNames(root) {
  return undeclaredAbsorbedPackages(root).map(function(param) {
    var [name] = param;
    return name;
  });
}
function absorbedPackageAliases(root, platform) {
  var absorbed = undeclaredAbsorbedPackages(root);
  if (!absorbed.length) return {};
  var oneRoot = import_path.default.dirname((0, import_resolve.resolvePath)("one/package.json", root));
  var entry = platform === "web" ? "index.mjs" : "index.native.js";
  return Object.fromEntries(absorbed.map(function(param) {
    var [name, dir] = param;
    return [
      name,
      import_path.default.join(oneRoot, "dist", "esm", dir, entry)
    ];
  }));
}
//# sourceMappingURL=absorbedPackages.js.map
